import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';
import * as Types from './actions/actionTypes';

const propTypes = {
};

export interface IInfoIconUIProps {
    pathname?: string;
    onIconClick?: Function;
}

export interface IInfoIconUIState {
}

export default class InfoIconUI extends Component<IInfoIconUIProps, IInfoIconUIState> {

    static defaultProps = {
    };

    constructor(props) {
        super(props);
    }

    private buildIcon(classes, route) {
        const className = `dr-ui-info-btn ${classes}`;
        const onClick = () => this.props.onIconClick(route);
        return(
            <div className={className} onClick={ onClick }></div>
        );
    }

    showIcon() {
        const { pathname } = this.props;

        let icon;

        switch (pathname) {
            case 'dealSummary':
                icon = null;
                break;
            case 'viewOffer':
                icon = this.buildIcon('info-close', Types.ROUTE_BACK);
                break;
            default:
                icon = this.buildIcon('info-circle', Types.ROUTE_VIEW_OFFER);
        }

        return icon;
    }

    render() {
        return (
            <div className="dr-ui-info-btn">
                {this.showIcon()}
            </div>
        );
    }
}

